import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PageChangedEvent} from 'ngx-bootstrap/pagination';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import {ApiService} from '../api.service';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {SharedService} from '../shared-service.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-commons-report-incident',
  templateUrl: './commons-report-incident.component.html',
  styleUrls: ['./commons-report-incident.component.css']
})
export class CommonsReportIncidentComponent implements OnInit {

  reportInvcidentList: any = [];
  // -Varibles para paginado de usuarios->
  pgBoundaryLinks = false; // Bandera que indica si se muestra Inicio/Fin del paginado
  pgMaxSize = 3; // Número de links en paginado
  pgItemsPerPage = 10; // Número de registros por página
  pgTotalItems: number; // Total de registros
  pgCurrentPage = 1; // Página actual
  private _paginationResponse: any = {};
  filters: any = {};
  filtersDownload: any = {};
  clientsSelectedItems: any = [];
  dropdownSettingsClients = {};
  groupsSelectedItems: any = [];
  dropdownSettingsGroups = {};
  clientList: any = [];
  groupList: any = [];
  branchList: any = [];
  branchSelectedItems: any = [];
  dropdownSettingsBranch: any = {};
  subBranchList: any = [];
  subBranchSelectedItems: any = [];
  dropdownSettingsSubBranch: any = {};
  executiveSurexList: any = [];
  surexSelectedItems: any = [];
  dropdownSettingsSurex: any = {};
  insuranceList: any = [];
  insurancesSelectedItems: any = [];
  dropdownSettingsInsurances = {};
  statusList: any = [];
  statusSelectedItems: any = [];
  dropdownSettingsStatus = {};
  typeRequestList: any = [];
  typeRequestSelectedItems: any = [];
  dropdownSettingstypeRequest = {};
  typeIncidentList: any = [];
  typeIncidentSelectedItems: any = [];
  filterRangeDate: Date[];
  bsConfig: Partial<BsDatepickerConfig>;
  @Output()
  pageChangedEvent = new EventEmitter();

  constructor(private api: ApiService,
              private router: Router,
              private toastr: ToastrService,
              private shared: SharedService,
              private spinner: NgxSpinnerService,
              private datePipe: DatePipe) {
  }

  ngOnInit() {


  }

  /**
   * Carga los datos según la página seleccionada
   */
  pageChanged(event: PageChangedEvent): void {
    this.pageChangedEvent.emit(event);

  }


  changeColorPagination() {
  }

  get paginationResponse(): any {
    return this._paginationResponse;
  }

  @Input()
  set paginationResponse(value: any) {
    this._paginationResponse = value;

    if ( this._paginationResponse === null) {
      this.reportInvcidentList = [];
      this.pgTotalItems = 0;
      return;
    }
    this.pgTotalItems = this._paginationResponse.totalRows;
    this.reportInvcidentList = this._paginationResponse.tList;
  }
}
